import RA from 'ra-config'
import result from 'lodash/result'

export function getFactorCategoryOrder({ Category }) {
  const list = result(RA, 'app.factors.categoryList', [])
  return list.findIndex(f => f.name === Category)
}

export function getStrategyCategoryOrder({ Category }) {
  const list = result(RA, 'app.strategies.categoryList', [])
  return list.findIndex(s => s.name === Category)
}

export function getFactorOrder({ Category, ID, Region }) {
  const list = result(RA, 'app.factors.categoryList', [])
  const category = list.find(f => f.name === Category)
  const order = result(category, ['factors', Region])

  return order ? order.indexOf(+ID) : 0
}

export function getStrategyOrder({ Category, ID, Region }) {
  if (Category === 'Benchmark') return 0

  const list = result(RA, 'app.strategies.categoryList', [])
  const category = list.find(s => s.name === Category)
  const order = result(category, ['strategies', Region])

  return order ? order.indexOf(+ID) : 0
}



// WEBPACK FOOTER //
// ./src/config/order.js